import './index.sass';

export default () => {
  $('.welcome-illustrator-popup__faq-heading').on('click', function (e) {
    $(this).closest('.welcome-illustrator-popup__faq-item').toggleClass('welcome-illustrator-popup__faq-item--active')
  });

  $('body').on('click', '.js-tariff-plan__payment', function() {
    $('.account-modal').fadeIn(300);
    $('.account-window').fadeIn(300);
    $('body').css('overflow', 'hidden');
    return false;
  });
}
